const kakaoMaps = window.kakao.maps;


class KakaoMap {
    #map;
    #prevActiveDiv;
    #overlays = {};

    static MAP_TYPE = {
        BRANCH : 0,
        COACH : 1,
    }

    constructor(el, lat, lng){
        var options = {
            center: new kakaoMaps.LatLng(lat, lng),
            level: 6
        };

        this.#map = new kakaoMaps.Map(el, options);
    }

    //마커 생성
    setMaker(lat, lng){
        const markerPosition  = new kakaoMaps.LatLng(lat, lng);

        const marker = new kakaoMaps.Marker({
            position: markerPosition
        });

        marker.setMap(this.#map);
    }

    //지도 드래그 변경시 이벤트
    addDragEndListener(callback){
        kakaoMaps.event.addListener(this.#map, 'dragend', () => {
            // const latlng = this.#map.getCenter();

            const {maxlat, maxlng, minlat, minlng} = this.getBounds();
            callback(maxlat, maxlng, minlat, minlng);
        });
    }

    //커스텀 오버레이 생성
    drawOverlay(html, lat, lng, activeHtml){
        if(Object.prototype.hasOwnProperty.call(this.#overlays, lat + '-' + lng)){
            return;
        }

        const wrapDiv = document.createElement('div');
        wrapDiv.innerHTML = html;

        const overlay = new kakaoMaps.CustomOverlay({
            content: wrapDiv,
            map: this.#map,
            position: new kakaoMaps.LatLng(lat, lng)
        });

        wrapDiv.addEventListener('click', () => {
            if(this.prevActiveDiv){
                this.prevActiveDiv.innerHTML = html;
            }
            this.prevActiveDiv = wrapDiv;
            wrapDiv.innerHTML = activeHtml;
        });

        overlay.setMap(this.#map);
        this.#overlays[lat + '-' + lng] = overlay;
    }

    getBounds(){
        // 지도 영역정보를 얻어옵니다
        const bounds = this.#map.getBounds();

        // 영역정보의 남서쪽 정보를 얻어옵니다
        const swLatlng = bounds.getSouthWest();

        // 영역정보의 북동쪽 정보를 얻어옵니다
        const neLatlng = bounds.getNorthEast();

        return {
            maxlat : neLatlng.getLat(),
            maxlng : neLatlng.getLng(),
            minlat : swLatlng.getLat(),
            minlng : swLatlng.getLng()
        };
    }

}



export default KakaoMap;




